import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { useHomeStickyBar } from './home/useHomeStickyBar';
import { useHomeScrollImageWarmup } from './home/useHomeScrollImageWarmup';
import { useHomeHeroVisibility } from './home/useHomeHeroVisibility';
import { resetHomeImagePriorityBudget } from './home/homeImagePriority';
import { HomeHero } from './home/sections/HomeHero';
import { HomePopularSection } from './home/sections/HomePopularSection';
import { HomeStartShoppingSection } from './home/sections/HomeStartShoppingSection';
import { HomeLookbookSection } from './home/sections/HomeLookbookSection';
import { HomeDropsWorkSection } from './home/sections/HomeDropsWorkSection';
import { HomeQualitySection } from './home/sections/HomeQualitySection';
import { HomeSocialProofSection } from './home/sections/HomeSocialProofSection';
import { HomeFaqNewsletterSection } from './home/sections/HomeFaqNewsletterSection';
import './home/Home.css';

const Home: React.FC = () => {
  const stickyShopRef = useRef<HTMLDivElement>(null);
  const heroRef = useRef<HTMLElement>(null);
  const priorityReset = useRef(false);
  if (!priorityReset.current) {
    resetHomeImagePriorityBudget();
    priorityReset.current = true;
  }
  useHomeStickyBar(stickyShopRef);
  useHomeScrollImageWarmup();
  useHomeHeroVisibility(heroRef);

  return (
    <div className="overflow-hidden">
      <HomeHero heroRef={heroRef} />
      <HomePopularSection />
      <HomeStartShoppingSection />
      <HomeLookbookSection />
      <HomeDropsWorkSection />
      <HomeQualitySection />
      <HomeSocialProofSection />
      <HomeFaqNewsletterSection />

      <div ref={stickyShopRef} className="home-sticky-shop sm:hidden" data-visible="0">
        <div className="home-sticky-shop__panel">
          <div className="flex items-center gap-3">
            <div className="min-w-0">
              <p className="text-xs font-semibold text-slate-500">Style picks</p>
              <p className="text-sm font-extrabold text-slate-900 truncate">Browse the shop</p>
            </div>
            <Link
              to="/shop"
              className="ml-auto inline-flex items-center justify-center px-4 py-2.5 rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold shadow-sm hover:shadow-md transition-all"
            >
              Shop Now
              <ArrowRightIcon className="ml-2 h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
